var error = [];
var _uncs_bMoznostRezervace = 0;

function _uncs_onLoad() {
  _uncs_changeColorVariant(); //Akce po kliknuti na option Color (maly obrazek barevne varianty)
  _uncs_changeLengthVariant(); //Zaveseni udalosti po kliknuti na volbu delky
  _uncs_setSkp(); //Nacteni SKP z prvni zvolene varianty
  _uncs_setMaterial(); //Nacteni a zobrazeni materialu z prvni zvolene barevne varianty
  _uncs_setBarva(); //Nacteni a zobrazeni barvy z prvni zvolene barevne varianty
  //_uncs_showLabels(); //Zobrazíme label k první zvolené variantě

  //Triger klik na první barevnou variantu mi odfiltruje nahledy obrazku podle zvolene varianty
  var uncs_currentVariant = document.querySelector("img.selectVariant.current");
  if (uncs_currentVariant) {
    uncs_currentVariant.click();
  }

  var a = document.querySelector("input.product-variant-id");
  a.addEventListener('change', function(){
    _uncs_setSkp();
  }, { once: true });
}

document.addEventListener("DOMContentLoaded", _uncs_onLoad);
subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, _uncs_onLoad);
subscribe(PUB_SUB_EVENTS.variantChange, _uncs_onLoad);

function _uncs_getSkp() {
  var skp = _uncs_skpZMetaObjektu();
    if (skp!='') { return skp; }

    //Kdyz se nepodarilo nacist SKP ve funkci _uncs_skuZMetaObjektu
    var uncs_currentVariant = document.querySelector("img.selectVariant.current"); //Toto vymenit u delek

    if (!uncs_currentVariant) { return; }
    return uncs_currentVariant.getAttribute("data-skp");
}

/**
 * Pokusim se precist SKU z JS promenne meta, kterou do stranky zapisuje sablona Dawn (predpokladam)
 * ID aktualni varianty ctu ze skryteho pole name="id" z formulare, ktery odesila zbozi do kosiku. Formular
 * je zalezitosti sablony Shopify a hodnota se meni po kazdem kliknuti na barevnou variantu, velikost, nebo delku
 */
function _uncs_skpZMetaObjektu() {
  let uncs_sku = '';
  if (typeof(meta)!="object") { return ''; } //Nepodarilo se nacist objekt meta, koncim. Nezmenila se sablona?

  //Naplnim aktualni id varianty.
  var uncs_formAdd = document.querySelector('form[action*="/cart/add"][method="POST"]');
  var uncs_uncs_formAdd_idVarianty = uncs_formAdd.querySelector('input[name="id"]').value;
  
  if (uncs_uncs_formAdd_idVarianty == '') { return ''; } //Nepodarilo se nacist id varianty. Nezmenila se sablona?


    for(let i = 0; i < meta.product.variants.length; i++){
      if (meta.product.variants[i]['id']!=uncs_uncs_formAdd_idVarianty) { continue; }
      let uncs_aVarianta = meta.product.variants[i];
      uncs_sku =  uncs_aVarianta.sku;
    }
    if (uncs_sku == '') { return ''; }

    let casti = uncs_sku.split("-"); // Rozdělí řetězec na pole podle pomlčky
    return casti[0];
}

/**
  Akce po kliknuti na option Color (maly obrazek barevne vrianty)
  Na kazdy obrazek (option) navesime udalost click
    Na click se:
      - odstrani css class current (ramecek kolem obrazku) na vsech obrazcich
      - prida class curent na obrazku na ktery se kliklo
      - schovaji se nahledy fotografii pod hlavni fotografii, ktere neodpovidaji zakliknute barevne variante
      - zapise se SKP do tagu <span id="data-skp"></span>
      - zapise se material do tagu <span id="data-material"></span>
*/
var _uncs_changeColorVariant = function () {
  // Vybereme všechny obrázky (options) s třídou 'selectVariants'
  var uncs_elements = document.querySelectorAll(".selectVariant");
  if (!uncs_elements) {
    return;
  }
  uncs_elements.forEach(function (element) {
    element.addEventListener("click", function () {
      _uncs_removeClassCurrentOnImgVariants(uncs_elements); //Odstranime tridu current
      this.classList.add("current"); //Pridame tridu current na aktivnim obrazku
      var uncs_idVariant = this.getAttribute("data-idVariant");
      var uncs_skp = this.getAttribute("data-skp");
      var uncs_targetElement = document.getElementById(uncs_idVariant);

      //Zobrazime/skryjeme nahledy fotografii pod hlavnim obrazkem
      if (uncs_targetElement) {
        uncs_targetElement.click();
        _uncs_filterColorImages(uncs_skp);
      }

      //Zobrazeni materialu
      _uncs_setMaterial();

      //Zobrazeni kodu barvy
      _uncs_setBarva();
      
      //Zobrazeni labelu
      //_uncs_showLabels();

      //Zjistime dostupnost SKP varianty. Funkce _uncs_getJSON_SkpNaProdejnach() je deklarována ve fragmentu uncs-rezervace-na-prodejne-modal,
      //který je vložen do stránky v sekci main-product. Tento fragment se vkládá pouze v české lokalizaci e-shopu, proto je tu podmínka, zda funkce vůbec existuje.
      if (typeof _uncs_getJSON_SkpNaProdejnach === "function") {
        _uncs_getJSON_SkpNaProdejnach(uncs_skp);
      }
    }, { once: true });
  });
};

function _uncs_changeLengthVariant() {
  var uncs_longVariants = document.querySelectorAll(
    "input[type='radio'][name='Length']"
  );
  if (!uncs_longVariants) {
    return;
  }
  uncs_longVariants.forEach(function (element) {
    element.addEventListener("click", function () {


      //Zjistime dostupnost SKP varianty. Funkce _uncs_getJSON_SkpNaProdejnach() je deklarována ve fragmentu uncs-rezervace-na-prodejne-modal,
      //který je vložen do stránky v sekci main-product. Tento fragment se vkládá pouze v české lokalizaci e-shopu, proto je tu podmínka, zda funkce vůbec existuje.
      if (typeof _uncs_getJSON_SkpNaProdejnach === "function") {
        _uncs_getJSON_SkpNaProdejnach();
      }
    }, { once: true });
  });
}

var _uncs_removeClassCurrentOnImgVariants = function (elements) {
  elements.forEach(function (img) {
    img.classList.remove("current");
  });
};

/****************************************************************
START zobrazeni/skryti nahledu

  Zobrazime/skryjeme nahledy fotografii pod hlavnim obrazkem,
  dle toho, ktera barevna varianta je zvolena
****************************************************************/
var _uncs_filterColorImages = function (uncs_skp) {
  document.querySelectorAll(".thumbnail-list__item")
    .forEach((thumbnail) => {
      if (thumbnail.getAttribute("data-skp") === uncs_skp) {
        thumbnail.style.display = 'list-item';
      } else {
        thumbnail.style.display = 'none';
      }
    });

  document.querySelectorAll(".product__media-list.slider--mobile .slider__slide")
    .forEach((thumbnail) => {
      if (thumbnail.getAttribute("data-skp") === uncs_skp) {
        thumbnail.classList.remove('hidden');
      } else {
        thumbnail.classList.add('hidden');
      }
    })
};

/****************************************************************
KONEC zobrazeni/skryti nahledu
****************************************************************/

/****************************************************************
START zapisu SKP, barvy a materialu do stranky
****************************************************************/

/****************************************************************
START zapisu SKP do stranky
* Zapise SKP aktualne vybrane varianty do tagu <span id="uncs-skp"></span> z atributu data-skp
* Paklize existuje vyber pro delku (kalhoty), bere hodnotu SKP z inputu volby velikosti.
* Kdyz delka neexistuje, bere se SKP z obrazku varianty. Aby funkce správně fungovala, musí
* být dodrženo pravidlo, že SKU je složeno ve formátu SKP-barva[-delka]-velikost a option v Shopify jsou pojmenované Color, Size, Length
****************************************************************/
function _uncs_setSkp() {
  var uncs_skp = _uncs_getSkp();
  if (typeof uncs_skp == "undefined") {
    return;
  }
  document.getElementById("uncs-skp").innerHTML = uncs_skp.toUpperCase();
}

/****************************************************************
START zapisu materialu do stranky
* Naplnim <span id="uncs-material"></span>
****************************************************************/
function _uncs_setMaterial() {
  uncs_currentVariant = document.querySelector("img.selectVariant.current"); //Pro potreby materialu se bere aktualni barevna varianta
  if (!uncs_currentVariant) {
    return;
  }
  var uncs_material = uncs_currentVariant.getAttribute("data-material");
  var uncs_material_container = document.getElementsByClassName(
    "uncs-material-container"
  );
  if (uncs_material != "") {
    document.getElementById("uncs-material").innerHTML =
      uncs_material.toLowerCase();
    uncs_material_container[0].style.display = "flex";
  } else if (uncs_material_container) {
    uncs_material_container[0].style.display = "none";
  }
}

/****************************************************************
START zapisu kodu barvy do stranky
* Naplnim <span id="uncs-color"></span>
****************************************************************/
function _uncs_setBarva() {
  uncs_currentVariant = document.querySelector("img.selectVariant.current");
  if (!uncs_currentVariant) {
    return;
  }
  var uncs_color = uncs_currentVariant.getAttribute("alt");
  var uncs_color_container = document.getElementsByClassName(
    "uncs-color-container"
  );
  if (uncs_color != "") {
    document.getElementById("uncs-color").innerHTML =
      uncs_color.toUpperCase();
    uncs_color_container[0].style.display = "flex";
  } else if (uncs_color_container) {
    uncs_color_container[0].style.display = "none";
  }
}
/****************************************************************
KONEC zapisu kodu SKP, barvy a materialu do stranky
****************************************************************/


/*****************************************************
 * Začátek
 * Nepoužívaný zápis/zobrazení štítků přes JS
 ****************************************************/
/*
function _uncs_showLabels(test) {
  uncs_currentVariant = document.querySelector("img.selectVariant.current"); //Pro potreby labelu se bere aktualni barevna varianta
  if (!uncs_currentVariant) {
    return;
  }
  _uncs_showLabelNew();
  _uncs_showLabelAction();
  _uncs_showLabelRecommended(test);    
}

function _uncs_showLabelNew() {
  var label = document.querySelector("span.uncs_card__label--new");
  var labelText = uncs_currentVariant.getAttribute("data-label-new"); 

  if (labelText!='') {
    label.style.setProperty("display", "inline-block", "important");
    label.textContent = labelText;
  }else{
    label.style.setProperty("display", "none", "important");
    label.textContent = "";
  }
}

function _uncs_showLabelAction() {
  var label = document.querySelector("span.uncs_card__label--action");
  var labelText = uncs_currentVariant.getAttribute("data-label-action");

  if (labelText!='') {
    label.style.setProperty("display", "inline-block", "important");
    label.textContent = labelText;
  }else{
    label.style.setProperty("display", "none", "important");
    label.textContent = "";
  }
}

function _uncs_showLabelRecommended(test) {
  var label = document.querySelector("span.uncs_card__label--recommended");
  var labelText = uncs_currentVariant.getAttribute("data-label-recommended");
  if (labelText=="1") {
    console.log('labelText style: block');
    label.style.setProperty("display", "inline-block", "important");
  }else{
    label.style.setProperty("display", "none", "important");
  }
}
*/
/*****************************************************
 * KONEC
 * Nepoužívaný zápis/zobrazení štítků přes JS
 ****************************************************/